import React from "react";
import styled, {
  css,
  type FlattenSimpleInterpolation,
} from "styled-components";
import { type BodyTextProps, Variant } from "../TextProps";
import { DefaultBodyStyles } from "./Body.styles";
import { FontLinkStyle } from "./variants";

export interface IBody3 extends BodyTextProps {
  componentName?: string;
}

export const Body3Styles = (
  props: BodyTextProps,
): FlattenSimpleInterpolation => {
  const variantLinkStyles =
    props.variant === Variant.LINK && FontLinkStyle("body3");
  return css`
    ${DefaultBodyStyles(props)};
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: 0.02rem;

    ${variantLinkStyles};
  `;
};

const StyledBody3 = styled.p<BodyTextProps>`
  ${Body3Styles}
`;

export const Body3: React.FC<IBody3> = ({
  tag = "p",
  children,
  componentName = "body3",
  ...props
}) => (
  <StyledBody3 as={tag} {...props} data-component={componentName}>
    {children}
  </StyledBody3>
);

export default Body3;
